module.exports = [{"type":"title","text":"2024-03-04"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Change perpetual contract: Place Order api supports TRAILING_TP_SL order type"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-03-04.json
// module id = VZgP
// module chunks = 3